// extracted by mini-css-extract-plugin
module.exports = {"namingInput":"Naming-namingInput-2Fl2E TextInput-input-3hT5a Input-input-2YWzR"};